import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { CustomTabsComponent } from '@app/app/shared/components/custom-tabs/custom-tabs.component';
import { ThingFeatureInterface } from '@app/app/shared/interfaces/thing/thing-feature.interface';
import { ThingSequenceInterface } from '@app/app/shared/interfaces/thing/thing-sequence.interface';
import { UpdatedSequenceInterface } from '../feature-item/custom-sequence-feature-item.component';

@Component({
  selector: 'custom-sequence-tracks',
  templateUrl: './custom-sequence-tracks.html',
  styleUrls: ['./custom-sequence-tracks.css'],
})

export class CustomSequenceTracksComponent implements OnInit, OnChanges {
  @Input() public features: ThingFeatureInterface[];
  @Input() public sequence: ThingSequenceInterface;
  @Input() public parkId: string;
  @Input() public id: string;
  
  @Output() updateSequence = new EventEmitter<UpdatedSequenceInterface>();

  @ViewChild('tabTrackGroup') tabTrackGroup: CustomTabsComponent;

  public tracks: string[] = new Array(4).fill('');
  public segments: string[] = new Array(4).fill('');
  public blocks: string[] = new Array(4).fill('');

  public sortedFeatures = [];

  objectKeys = Object.keys;

  constructor() {
  }

  public updateSequenceTrack(event: UpdatedSequenceInterface) {
    this.updateSequence.emit(event);
  }

  public sortFeatures() {
    this.sortedFeatures = [];

    Object.keys(this.features).forEach((featureId) => {
      const feature = {...this.features[featureId]};

      Object.keys(this.sequence).forEach((attrId) => {
        if (attrId == featureId) {
          feature['activeTracks'] = Object.values(this.sequence[attrId].on)
        }
      })

      this.sortedFeatures.push([featureId, feature, parseInt(feature.sOr || 0, 10)]);
    });

    // sort by sort order, then by name
    this.sortedFeatures.sort((a, b) => {
      return a[2] - b[2] || a[1].nm.localeCompare(b[1].nm);
    });
  }

  ngOnInit(): void {
    this.sortFeatures();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sequence && changes.sequence.currentValue !== changes.sequence.previousValue) {
      this.sortFeatures();

      if (this.tabTrackGroup && changes.sequence.previousValue && changes.sequence.currentValue.sequenceId !== changes.sequence.previousValue.sequenceId) {
        this.tabTrackGroup.clearTabs();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/custom-sequences/tracks/custom-sequence-tracks.component.ts